import React from "react";
import Button from "./sub-components/Button";
import { motion } from "framer-motion";

function Hero() {
  return (
    <motion.main
      className="md:mt-[5%] mt-[20%] flex flex-col md:items-start items-center md:h-screen md:mb-0 mb-[200px]"
      initial={{ y: "-100vh", opacity: 0.1 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: "spring", delay: 0.5, stiffness: 120 }}
    >
      <h1 className="">Hi, there 👋! My name is</h1>
      <motion.h1
        className="font-bold text-2xl md:text-6xl mb-[10px] md:mb-[30px] md:block hidden "
        initial={{ marginTop: 10 }}
        animate={{ marginTop: 0 }}
      >
        Qozeem Opeyemi Salami
      </motion.h1>
      <h1 className="font-bold text-4xl md:text-6xl mb-[10px] md:mb-[30px] md:hidden">
        Qozeem Salami
      </h1>
      <p className="text-justify md:w-[60%] px-[50px] md:px-0   md:mx-0 md:text-start text-xs md:text-base">
        I am a web developer with a knack for building responsive, interactive,
        and beautiful user interfaces. My attention to detail and creativity
        allow me to implement user interfaces that not only look stunning but
        also function flawlessly.
      </p>
      <div className=" mt-[50px]">
        <Button />
      </div>
    </motion.main>
  );
}

export default Hero;
